import React from "react";
// ICONS
import StorefrontIcon from "@material-ui/icons/Storefront";

export const google_calendar = "google_calendar";
export const facebook_pixel = "facebook_pixel";
export const google_analytics = "google_analytics";
export const domain_linking = "domain_linking";
export const wordpress = "wordpress";
export const pabbly = "pabbly";
export const zoom = "zoom";
export const custom_code = "custom_code";
export const integration_key__e_invoice_customer = "einvoice_customer";
export const zapier = "zapier";
export const shiprocket = "shiprocket";
export const email_sender_ids = "email_sender_ids";
export const whatsapp = "whitelabelled_whatsapp";
export const instagram = "instagram";
export const telegram = "telegram";
// Comming Soon
export const wix = "wix";

export const INTEGRATIONS_PAGE_TITLE = "Integration";

export const INTEGRATIONS_LEARN_MORE_HREFS = {
  INTEGRATIONS: "https://support.exlyapp.com/support/solutions/84000149953",
};

export const PLUGIN_URLS = {
  [wordpress]: "https://wordpress.org/plugins/exly-wp/",
  [zoom]: "https://marketplace.zoom.us/apps/LPcE_wxVRfavPBNaaID14w",
  [zapier]: "https://zapier.com/",
  [shiprocket]: {
    signup: "https://app.shiprocket.in/register",
    configureApi: "https://app.shiprocket.in/api-user",
  },
};

export const INTEGRATIONS_STATUS_VALUE = {
  CONNECTED: 1,
  DISCONNECTED: 2,
  FEATURE_LOCK: 3,
  PLAN_LOCK: 4,
  COMING_SOON: 5,
  ACCESS_LOCKED: 6,
  ACCESS_REQUESTED: 7,
  ACCESS_GRANTED: 8,
  ACCESS_DENIED: 9,
  ACCESS_EXPIRED: 10,
};

export const integration_cards_keys = {
  slug: "slug",
  syncText: "syncText", // the key represents the sync text when `status === INTEGRATIONS_STATUS_VALUE.CONNECTED`
  pre_sync: "pre_sync", // used when `status !== INTEGRATIONS_STATUS_VALUE.CONNECTED`
  learn_more: "learn_more",
  learn_more_href: "learn_more_href",
  description: "description",
  image: "image",
  status: "status",
  title: "title",
  accessExpired: "accessExpired", // the key represents the sync text when `status === INTEGRATIONS_STATUS_VALUE.ACCESS_EXPIRED`
};

// integrations meta data which is used in integration card page.
export const integrations_cards = {
  [zapier]: {
    slug: zapier,
    syncText: "Connected",
    learn_more: "Connect Zapier",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392241-integrate-zapier-with-exly",
    priority: 1,
  },
  [pabbly]: {
    slug: pabbly,
    syncText: "Connected",
    learn_more: "Connect Pabbly",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392240-integrate-pabbly-with-exly",
    priority: 2,
  },
  [whatsapp]: {
    slug: whatsapp,
    learn_more: "Connect WhatsApp",
    syncText: "Connected",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000392245-how-to-white-label-your-whatsapp-communications",
    priority: 3,
  },
  [instagram]: {
    slug: instagram,
    learn_more: "Connect Instagram",
    syncText: "Connected",
    accessExpired: "De-linked",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000392245-how-to-white-label-your-whatsapp-communications",
    priority: 4,
  },
  [telegram]: {
    slug: telegram,
    learn_more: "Learn more",
    syncText: "Connected",
    accessExpired: "De-linked",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000392245-how-to-white-label-your-whatsapp-communications",
    priority: 5,
  },
  [email_sender_ids]: {
    slug: email_sender_ids,
    syncText: "Manage sender IDs",
    learn_more: "Manage sender IDs",
    learn_more_href: "https://support.exlyapp.com/support/home",
    priority: 6,
  },
  [integration_key__e_invoice_customer]: {
    slug: integration_key__e_invoice_customer,
    syncText: "", // intentionally empty, to hide the sync button
    learn_more: "Activate e-invoices",
    priority: 7,
  },
  [wordpress]: {
    slug: wordpress,
    syncText: "Connected",
    pre_sync: {
      icon: <StorefrontIcon />,
      text: "Visit marketplace",
      redirect: PLUGIN_URLS[wordpress],
    },
    learn_more: "Connect Wordpress",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392239-integrate-wordpress-with-exly",
    priority: 8,
  },
  [shiprocket]: {
    slug: shiprocket,
    syncText: "Connected",
    learn_more: "Add Shiprocket",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392238-integrate-shiprocket-with-exly",
    priority: 9,
  },
  [google_calendar]: {
    slug: google_calendar,
    syncText: "Connected",
    learn_more: "Connect calendars",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000355034-integrate-google-calendar-with-exly",
    priority: 10,
  },
  [facebook_pixel]: {
    slug: facebook_pixel,
    syncText: "Connected",
    learn_more: "Connect Facebook Pixel",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000355064-integrate-facebook-pixel-with-exly",
    priority: 11,
  },
  [google_analytics]: {
    slug: google_analytics,
    syncText: "Connected",
    learn_more: "Connect Google Analytics",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000355066-integrate-google-analytics-with-exly",
    priority: 12,
  },
  [domain_linking]: {
    slug: domain_linking,
    name: "domainName",
    syncText: "Connected",
    learn_more: "Link your domain",
    learn_more_href:
      "https://support.exlyapp.com/support/solutions/articles/84000354964-set-up-a-custom-domain-name-on-exly",
    priority: 13,
  },
  [zoom]: {
    slug: zoom,
    syncText: "Connected",
    pre_sync: {
      icon: <StorefrontIcon />,
      text: "Visit marketplace",
      redirect: PLUGIN_URLS[zoom],
    },
    learn_more: "Connect Zoom",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392237-integrate-zoom-with-exly",
    priority: 14,
  },
  [custom_code]: {
    slug: custom_code,
    syncText: "Integrated",
    learn_more: "Add Custom Code",
    learn_more_href:
      "https://support.exlyapp.com/en/support/solutions/articles/84000392236-integrate-custom-code-with-exly",
    priority: 15,
  },
  // Comming Soon
  [wix]: {
    slug: wix,
    priority: 16,
  },
};
